// Настройки общей (SSO) куки сессии.
//
// Оба приложения — это (assessment.ezspeech.ai) и «Интеллект»
// (intellect.ezspeech.ai) — работают с одним проектом Supabase. Сессия
// хранится не в localStorage, а в куке, выданной на РОДИТЕЛЬСКИЙ домен
// (.ezspeech.ai) — именно поэтому вход на одном хосте виден на другом.
//
// Два правила, ради которых этот файл существует:
//   1. Имя куки должно совпадать в обоих приложениях, иначе ни одно не увидит
//      сессию другого. Здесь оно константой, зеркало —
//      ezspeech-assessment/src/lib/authCookie.ts. Меняете одно — меняйте оба.
//   2. Домен нельзя задавать константой на окружение. Он выводится из хоста,
//      на котором приложение реально открыто: раньше здесь стояло
//      isDev ? '.local.test' : '.ezspeech.ai', и это ровно тот же класс ошибки,
//      из-за которого в прод уехала ссылка на localhost.

export const AUTH_COOKIE_NAME = 'sb-ezspeech-auth-token';

/**
 * Родительский домен для куки по хосту, на котором открыто приложение.
 * Возвращает undefined, когда куку нужно оставить host-only.
 *
 *   assessment.ezspeech.ai -> .ezspeech.ai   (общая с intellect.ezspeech.ai)
 *   assessment.local.test  -> .local.test    (общая с intellect.local.test)
 *   localhost / 127.0.0.1  -> undefined      (делиться не с кем)
 *
 * Голый апекс (ezspeech.ai) — тоже undefined: расширение до '.ai' браузер
 * отвергнет как публичный суффикс, да и соседнего хоста там нет.
 */
export function resolveCookieDomain(hostname) {
  if (!hostname) return undefined;

  // IPv4-литерал или хост в скобках (IPv6) — домен у куки невозможен.
  if (/^\[|^\d+\.\d+\.\d+\.\d+$/.test(hostname)) return undefined;

  const labels = hostname.split('.').filter(Boolean);

  if (labels.length < 3) return undefined;

  return '.' + labels.slice(1).join('.');
}

/**
 * cookieOptions для createBrowserClient.
 * secure следует за реальной схемой, а не за флагом dev/prod: Secure-кука по
 * обычному http молча отбрасывается — именно так это и ломается.
 */
export function authCookieOptions(location) {
  return {
    name: AUTH_COOKIE_NAME,
    domain: process.env.REACT_APP_AUTH_COOKIE_DOMAIN || resolveCookieDomain(location.hostname),
    path: '/',
    sameSite: 'lax',
    secure: location.protocol === 'https:',
  };
}
